module.exports = __webpack_public_path__ + "img/Microsoft-logo_rgb_c-gray.7efb873d.png";